import analytics from '@finn-no/analytics';
import pulse from '@finn-no/pulse-sdk';

document.addEventListener('DOMContentLoaded', () => {
    const searchLinks = document.getElementById('search-links');
    const isBap = window.location.href.includes('/bap');

    if (searchLinks) {
        searchLinks.querySelectorAll('a').forEach((el) => {
            el.addEventListener('click', () => {
                const categoryId = el.getAttribute('data-category');

                analytics.trackEventLater({
                    analyticsName: 'navigation.filter-by-category.click',
                    stringValue: `location:bapfront,category:${categoryId}`,
                });

                if (isBap) {
                    const categoryName = el.getAttribute('data-category-name');

                    const event = {
                        name: 'Go to category listing',
                        intent: 'Open',
                        type: 'Click',
                        object: {
                            name: categoryName,
                            position: 'Main',
                            type: 'UIElement',
                            elementType: 'Link',
                            page: {
                                type: 'MarketFrontpage',
                            },
                        },
                        target: {
                            id: 'Listing',
                            name: 'Listing',
                            pageType: 'Listing',
                        },
                        vertical: {
                            name: 'bap',
                        },
                    };

                    pulse.trackEvent(event);
                }
            });
        });
    }
});
